import BurgerIconSvg from "assets/landing/icons/BurgerIconSvg";
import React from "react";
type BurgerIconProps = {
  handleClick?: () => void;
};
const BurgerIcon: React.FC<BurgerIconProps> = ({ handleClick }) => {
  return (
    <button
      onClick={handleClick}
      className="size-11 flex lg:hidden items-center justify-center  bg-[#E9EBF3] custom-shadow burger-icon rounded-xl"
    >
      <span className="size-7 flex items-center justify-center rounded-[4px] bg-white">
        <BurgerIconSvg />
      </span>
    </button>
  );
};

export default BurgerIcon;
